// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__tF2RZ","fluid":"Container_fluid__1Mj8-"};